<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/accident/index"
        :tableData.sync="tableData"
        :columns="columns"
		    :searchParams="searchData">
        <template #handle="{ row }">
          <el-button type="text" size="mini" v-if="row.status == 1 && row.acceptance_images == null" @click="handleRow(row, 'acceptance')">受理处理</el-button>
          <el-button type="text" size="mini" v-if="row.status == 1 && row.acceptance_images != null" @click="handleRow(row, 'repair')">维修处理</el-button>
          <el-button type="text" size="mini" v-if="row.status == 2" @click="handleRow(row, 'completed')">维修完毕</el-button>
          <el-button type="text" size="mini" v-if="row.status == 3 && row.type == 0" @click="handleRow(row, 'review')">补偿审核</el-button>
          <el-button type="text" @click="handleRow(row, 'detail')">详情</el-button>
          <el-button type="text" v-if="row.status != 4" @click="handleRow(row, 'edit')">编辑</el-button>
          <el-button type="text" v-if="row.status != 4" size="mini" @click="handleRow(row, 'del')">删除</el-button>
        </template>
      </BaseTable>
      <!-- 受理处理 -->
      <el-dialog  title="维修完毕" :visible.sync="CodeAcceptanceBefor" width="40%" @close="CodeAcceptanceBefor = false">
        <el-form inline ref="completedata" label-width="150px" class="demo-ruleForm">
            <el-form-item class="from-item--30" label="受理照片" prop="acceptancePhoto" >
              <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
                list-type="picture-card" :file-list="acceptancePhoto" :limit="10"
                :on-preview="handlePictureCardPreview" :on-change="(file) => handleChangeFile(file, 4)"
                :auto-upload="false" :on-remove="(file, fileList) => handleRemoveImg(file, fileList, 4)
                  ">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <br>
            <div style="margin-left:50px;">
              <el-button size="mini" @click="CodeAcceptanceBefor = false">取消</el-button>
              <el-button size="mini" @click="setAcceptance">确定</el-button>
            </div>
          </el-form>
      </el-dialog>
      <!-- 维修处理 -->
      <el-dialog  title="维修处理" :visible.sync="CodeRepairBefor" width="40%" @close="CodeRepairBefor = false">
        <el-form inline ref="repair_data" label-width="150px" class="demo-ruleForm">
            <el-form-item class="from-item--30" label="理赔员" prop="adjusters" >
              <el-input v-model="adjusters" placeholder="理赔员" />
            </el-form-item>
            <br>
            <el-form-item class="from-item--30" label="维修照片" prop="repairPhoto" >
              <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
                list-type="picture-card" :file-list="repairPhoto" :limit="10"
                :on-preview="handlePictureCardPreview" :on-change="(file) => handleChangeFile(file, 1)"
                :auto-upload="false" :on-remove="(file, fileList) => handleRemoveImg(file, fileList, 1)
                  ">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <br>
            <el-form-item class="from-item--30" label="维修厂" prop="store" >
              <el-select v-model="store_id" placeholder="请选择维修厂" filterable>
              <el-option v-for="item in $store.state.app.store" :key="item.key" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <br>
            <div style="display: flex;">
              <!-- <FoldedPanel style="width: 45%;margin-left: 3%;">
                  <template #title>
                    <span class="panel-header-text"><i class="icon el-icon-menu">维修项目</i></span>
                  </template>
                  <el-table :data="projectList" style="width: 100%">
                    <el-table-column prop="isCheck" label="选择" width="50">
                      <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.isCheck"></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" min-width="150" label="项目">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.name }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="money" label="金额(元)">
                      <template slot-scope="scope">
                        <span v-if="!scope.row.isCheck">0元</span>
                        <div class="input-wrap" v-if="scope.row.isCheck">
                          <el-input v-model="scope.row.money" placeholder="元">
                          </el-input>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
              </FoldedPanel>
              <FoldedPanel style="width: 45%;margin-left: 4%;">
                  <template #title>
                    <span class="panel-header-text"><i class="icon el-icon-menu">备件更换项目</i></span>
                  </template>
                  <el-table :data="partList" style="width: 100%">
                    <el-table-column prop="isCheck" label="选择" width="50">
                      <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.isCheck"></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" min-width="150" label="项目">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.name }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="money" label="金额(元)">
                      <template slot-scope="scope">
                        <span v-if="!scope.row.isCheck">0元</span>
                        <div class="input-wrap" v-if="scope.row.isCheck">
                          <el-input v-model="scope.row.money" placeholder="元">
                          </el-input>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
              </FoldedPanel> -->
              <FoldedPanel style="width: 45%;margin-left: 3%;">
                <template #title>
                  <span class="panel-header-text"><i class="icon el-icon-menu">维修项目</i></span>
                </template>
                <el-table :data="projectList" style="width: 100%">
                  <el-table-column prop="name" min-width="100" label="项目">
                    <template slot-scope="scope">
                      <div class="input-wrap">
                        <el-input v-model="scope.row.name" placeholder="项目名称"></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="money" min-width="100" label="工时(小时)">
                    <template slot-scope="scope">
                      <div class="input-wrap">
                        <el-input v-model="scope.row.money" placeholder="项目工时"></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="set" label="操作">
                    <template slot-scope="scope">
                      <div class="input-wrap">
                        <el-button v-if="scope.$index == 0" size="mini" @click="handleprojectAdd()">增加</el-button>
                        <el-button v-if="scope.$index > 0" size="mini" @click="handleprojectDel(scope.$index)" type="danger">删除</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </FoldedPanel>
              <FoldedPanel style="width: 45%;margin-left: 3%;">
                <template #title>
                  <span class="panel-header-text"><i class="icon el-icon-menu">备件更换项目</i></span>
                </template>
                <el-table :data="partList" style="width: 100%">
                  <el-table-column prop="name" min-width="100" label="项目">
                    <template slot-scope="scope">
                      <div class="input-wrap">
                        <el-input v-model="scope.row.name" placeholder="项目名称"></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="money" min-width="100" label="金额(元)">
                    <template slot-scope="scope">
                      <div class="input-wrap">
                        <el-input v-model="scope.row.money" placeholder="项目金额"></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="set" label="操作">
                    <template slot-scope="scope">
                      <div class="input-wrap">
                        <el-button v-if="scope.$index == 0" size="mini" @click="handlepartAdd()">增加</el-button>
                        <el-button v-if="scope.$index > 0" size="mini" @click="handlepartDel(scope.$index)" type="danger">删除</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </FoldedPanel>
            </div>
            <div style="margin-left:50px;">
              <el-button size="mini" @click="CodeRepairBefor = false">取消</el-button>
              <el-button size="mini" @click="setRepair">确定</el-button>
            </div>
          </el-form>
      </el-dialog>
      <!-- 维修完毕 -->
      <el-dialog  title="维修完毕" :visible.sync="CodeCompletedBefor" width="40%" @close="CodeCompletedBefor = false">
        <el-form inline ref="completedata" label-width="150px" class="demo-ruleForm">
            <el-form-item class="from-item--30" label="车损维修金额" prop="money" >
              <el-input v-model="money" :disabled="is_money" placeholder="车损维修金额" />
            </el-form-item>
            <br>
            <el-form-item class="from-item--30" label="三者赔付金额" prop="szmoney" >
              <el-input v-model="szmoney" :disabled="is_szmoney" placeholder="三者赔付金额" />
            </el-form-item>
            <br>
            <el-form-item class="from-item--30" label="责任认定比例" prop="szmoney" >
              <el-input v-model="proportion" :disabled="is_szmoney" placeholder="责任认定比例" />
            </el-form-item>
            <br>
            <el-form-item class="from-item--30" label="定损金额" prop="szmoney" >
              <el-input v-model="amount" :disabled="is_szmoney" placeholder="定损金额" />
            </el-form-item>
            <br>
            <el-form-item class="from-item--30" label="配件残值" prop="szmoney" >
              <el-input v-model="accessories" :disabled="is_szmoney" placeholder="配件残值" />
            </el-form-item>
            <br>
            <el-form-item class="from-item--30" label="完工照片" prop="completedPhoto" >
              <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
                list-type="picture-card" :file-list="completedPhoto" :limit="10"
                :on-preview="handlePictureCardPreview" :on-change="(file) => handleChangeFile(file, 2)"
                :auto-upload="false" :on-remove="(file, fileList) => handleRemoveImg(file, fileList, 2)
                  ">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <br>
            <div style="margin-left:50px;">
              <el-button size="mini" @click="CodeCompletedBefor = false">取消</el-button>
              <el-button size="mini" @click="setCompleted">确定</el-button>
            </div>
          </el-form>
      </el-dialog>
      <!-- 补偿审核 -->
      <el-dialog  title="补偿审核" :visible.sync="CodeReviewBefor" width="40%" @close="CodeReviewBefor = false">
        <el-form inline ref="completedata" label-width="150px" class="demo-ruleForm">
            <el-form-item class="from-item--30" label="类型" prop="claims_type">
              <el-select v-model="claims_type" filterable>
                <el-option label="平台承担" value="1"></el-option>
                <el-option label="进行分摊" value="2"></el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item class="from-item--30" label="备注" prop="beizhu" >
              <el-input v-model="beizhu" placeholder="备注" />
            </el-form-item>
            <br>
            <div style="margin-left:50px;">
              <el-button size="mini" @click="CodeReviewBefor = false">取消</el-button>
              <el-button size="mini" @click="setReview">确定</el-button>
            </div>
          </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";
import { status } from "nprogress";

export default {
  name: "Log",
  comments: {},
  data() {
    return {
      acceptancePhoto: [],
      repairPhoto:[],
      completedPhoto:[],
      tableData: [],
      searchData: {},
      CodeRepairBefor:false,
      CodeCompletedBefor:false,
      CodeReviewBefor:false,
      CodeAcceptanceBefor:false,
      id:0,
      adjusters:'',
      store_id:'',
      money:0,
      szmoney:0,
      claims_type:'',
      beizhu:'',
      is_money:false,
      is_szmoney:false,
      partList:[
        {name:'',money:''}
      ],
      projectList:[
        {name:'',money:''}
      ],
      proportion:0,
      amount:0,
      accessories:0,
    };
  },
  computed: {
    searchFormOption,
    columns
  },
  created() {
    this.$store.dispatch('app/getStore')
  },
  methods: {
    handleprojectAdd(){
        this.projectList.push({
          name: '',
          money: ''
        });
    },
    handleprojectDel(key){
      this.projectList.splice(key,1);
    },
    handlepartAdd(){
        this.partList.push({
          name: '',
          money: ''
        });
    },
    handlepartDel(key){
      this.partList.splice(key,1);
    },
    // async getProject(){
    //   const res = await this.$api.post('/admin/repair/project', { status: 1,id:this.id})
    //   this.projectList = res.data.data
    // },
    // async getPart(){
    //   const res = await this.$api.post('/admin/repair/part', { status: 1,id:this.id})
    //   this.partList = res.data.data
    // },
    // 图片上传之前
    handlePictureCardPreview(file) {
        this.preImageUrl = file.url;
        this.preVisible = true;
    },
    // 删除图片
    handleRemoveImg(res, fileList, item) {
      if(item == 1){
        this.repairPhoto = this.repairPhoto.filter((el) => el.url !== res.url);
      } else if(item == 4){
        this.acceptancePhoto = this.acceptancePhoto.filter((el) => el.url !== res.url);
      } else {
        this.completedPhoto = this.completedPhoto.filter((el) => el.url !== res.url);
      }
      
    },

    async handleChangeFile(file, item) {
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      const res = await this.$api.upload("/admin/upload/upimg", fd);
      if (res.code === 10000) {
        this.$message.success("上传成功");
        if(item == 1){
          this.repairPhoto.push({
            imageType: 1,
            url: res.data.path,
          });
        } else if (item == 4) {
          this.acceptancePhoto.push({
            imageType: 4,
            url: res.data.path,
          });
        } else {
          this.completedPhoto.push({
            imageType: 2,
            url: res.data.path,
          });
        }
        
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },
    handleRow(row, k) {
      switch (k) {
        case "detail":
          this.handleDetail(row);
          break;
        case "edit":
          this.handleEdit(row);
          break;
        case "del":
          this.handleDel(row);
          break;
        case "repair":
          this.getRepair(row);
          break;
        case "completed":
          this.getCompleted(row,row,row);
          break;
        case "review":
          this.getReview(row);
          break;
        case "acceptance":
          this.getAcceptance(row);
        break;
        default:
          break;
        }
    },
    getAcceptance({ id }){
      this.id = id
      this.CodeAcceptanceBefor = true;
    },
    setAcceptance(){
      const res = this.$api.post("/admin/accident/setDerepair", {
        id: this.id,
        acceptancePhoto: this.acceptancePhoto,
        status: 1
      });
      this.CodeAcceptanceBefor = false;
      this.acceptancePhoto = [];
      let that = this;
      setTimeout(() => {
        that.handleSearch();
      }, 1000);
      
    },
    getReview({ id }){
      this.id = id
      this.CodeReviewBefor = true;
    },
    setReview(){
      const res = this.$api.post("/admin/accident/setDerepair", {
        id: this.id,
        claims_type: this.claims_type,
        beizhu: this.beizhu,
        status: 4
      });
      this.CodeReviewBefor = false;
      this.claims_type = 0;
      this.beizhu = '';
      let that = this;
      setTimeout(() => {
        that.handleSearch();
      }, 1000);
      
    },
    getCompleted({ id },{ is_money },{ is_szmoney }){
      if(is_money != 1){
        this.is_money = true
      }
      if(is_szmoney != 1){
        this.is_szmoney = true
      }
      this.id = id
      this.CodeCompletedBefor = true;
    },
    setCompleted(){
      const res = this.$api.post("/admin/accident/setDerepair", {
        id: this.id,
        money: this.money,
        szmoney: this.szmoney,
        proportion: this.proportion,
        amount: this.amount,
        accessories: this.accessories,
        completedPhoto: this.completedPhoto,
        status: 3,
      });
      this.CodeCompletedBefor = false;
      this.money = 0;
      this.szmoney = 0;
      this.completedPhoto = [];
      let that = this;
      setTimeout(() => {
        that.handleSearch();
      }, 1000);
    },
    getRepair({ id }){
      this.id = id
      this.CodeRepairBefor = true;
      // this.getProject();
      // this.getPart();
    },
    setRepair(){
      const res = this.$api.post("/admin/accident/setDerepair", {
        id: this.id,
        adjusters: this.adjusters,
        store_id: this.store_id,
        repairPhoto: this.repairPhoto,
        projectList: this.projectList,
        partList: this.partList,
        status: 2
      });
      this.CodeRepairBefor = false;
      this.adjusters = '';
      this.store = '';
      this.repairPhoto = [];
      let that = this;
      setTimeout(() => {
        that.handleSearch();
      }, 1000);
    },
    // 点击详情
    handleDetail({ id }) {
      this.$router.push({
        path: "/accident/detail",
        query: {
          id,
        },
      });
    },
    // 点击编辑
    handleEdit({ id }) {
      this.$router.push({
        path: "/accident/apply",
        query: {
          id,
        },
      });
    },
    // 点击删除
    handleDel({ id }) {
      this.$confirm(`是否确认删除【ID${id}】申请记录, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post(
            "/admin/accident/delLog",
            { id: id },
            "删除"
          );
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
  },
};
</script>
